import React, { useEffect, useState } from "react";
import {
  Box,
  Stack,
  Typography,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import toast from "react-hot-toast";
import { URL } from "../config";

const AddPackageSubTypeModal = ({ onClose, packagesubtype }) => {
  const [packageSubTypeName, setPackageSubTypeName] = useState(
    packagesubtype?.packageSubTypeName || ""
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPackageSubTypeName(packagesubtype?.packageSubTypeName || "");
  }, [packagesubtype]);

  const handleSubmit = async () => {
    if (!packageSubTypeName.trim()) {
      toast.error("Please enter package sub type name");
      return;
    }

    setLoading(true);
    try {
      if (packagesubtype) {
        await axios.patch(
          `${URL}/packagesubtypes/${packagesubtype.packageSubTypeId}`,
          { packageSubTypeName }
        );
        toast.success("Package sub type updated successfully");
      } else {
        await axios.post(`${URL}/packagesubtypes`, {
          packageSubTypeName,
        });
        toast.success("Package sub type added successfully");
      }
      setTimeout(() => onClose?.(), 400);
    } catch (err) {
      console.error(err);
      toast.error("Operation failed");
    } finally {
      setLoading(false);
    }
  };

  const fieldStyle = {
    "& .MuiOutlinedInput-root": {
      minHeight: "28px",
      fontSize: "14px",
      "& fieldset": { borderColor: "#c4c4c4" },
      "&:hover fieldset": { borderColor: "#184459ff" },
      "&.Mui-focused fieldset": {
        borderColor: "#c4c4c4",
        borderWidth: "1.5px",
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: "18px",
      color: "#184459ff",
      fontWeight: 600,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#184459ff",
    },
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1300,
        p: 2,
      }}
    >
      <Box
        sx={{
          width: { xs: "90%", sm: 400 },
          bgcolor: "#fff",
          borderRadius: 2,
          p: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{ textAlign: "center", color: "#184459ff", mb: 2 }}
        >
          {packagesubtype ? "Edit Package Sub Type" : "Add Package Sub Type"}
        </Typography>

        <Stack spacing={2}>
          <TextField
            fullWidth
            size="small"
            label="Package Sub Type Name"
            value={packageSubTypeName}
            onChange={(e) => setPackageSubTypeName(e.target.value)}
            sx={fieldStyle}
            InputLabelProps={{ shrink: true }}
          />

          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#184459ff",
                "&:hover": { backgroundColor: "#184459ff" },
              }}
              onClick={handleSubmit}
              startIcon={loading && <CircularProgress size={18} />}
            >
              {loading ? "Saving..." : packagesubtype ? "Update" : "Save"}
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#757575ff",
                "&:hover": { backgroundColor: "#757575ff" },
              }}
              onClick={onClose}
            >
              Close
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default AddPackageSubTypeModal;
